<template>
  <div v-show="visible">
    <div class="box-btn">
      <el-button
        v-access:modify
        type="primary"
        icon="el-icon-edit"
        :loading="isLoading"
        @click="saveType"
        size="small"
        >保存</el-button
      >
    </div>
    <el-form
      ref="form"
      :model="form"
      label-width="120px"
      :rules="rules"
      v-loading="isLoading"
    >
      <el-form-item label="上级栏目：" prop="ParentId">
        <el-cascader
          v-model="form.ParentId"
          :options="options"
          @change="handleChange"
          clearable
          :props="{
            checkStrictly: true,
            expandTrigger: 'hover',
            value: 'id',
            label: 'text',
          }"
        />
      </el-form-item>
      <el-form-item label="栏目名称：" prop="TypeName">
        <el-input
          placeholder="栏目名称"
          v-model="form.TypeName"
          clearable
          maxlength="50"
        />
      </el-form-item>
      <el-form-item label="栏目编码：" prop="Code">
        <el-input
          placeholder="栏目编码"
          v-model="form.Code"
          clearable
          maxlength="50"
        />
      </el-form-item>
      <el-form-item label="排序：" prop="Sort">
        <el-input
          placeholder="请输入排序数字"
          v-model="form.Sort"
          clearable
          maxlength="10"
        />
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import api from "@/modules/zjrc/api/index.js";
import departmentBakVue from '../../../../sys/components/picker/department.bak.vue';

export default {
  data() {
    return {
      form: {
        ParentId: "",
        ParentName: "",
        TypeName: "",
        Code: "",
        Sort: undefined,
      },
      rules: {
        TypeName: {
          required: true,
          message: "栏目名称不能空",
          trigger: "blur",
        },
        Code: { required: true, message: "栏目编码不能空", trigger: "blur" },
        Sort: { required: true, message: "排序不能空", trigger: "blur" },
      },
      isLoading: false,
      options: [],
      visible: false,
    };
  },
  methods: {
    onCancel(){
      const vm = this
      vm.visible = false
      vm.form = {
        ParentId: "",
        ParentName: "",
        TypeName: "",
        Code: "",
        Sort: undefined,
      }
    },
    saveType() {
      const vm = this;
      vm.$refs.form.validate((valid) => {
        if (valid) {
          const param = Object.assign({}, vm.form);
          if(Array.isArray(param.ParentId) && param.ParentId.length > 0){
            param.ParentId = param.ParentId[param.ParentId.length - 1]
          }
          
          vm.isLoading = true;
          api
            .SaveNewsType(param)
            .then((res) => {
              if (res.data.Code === 0) {
                this.$message({
                  message: "提交成功",
                  type: "success",
                });
                vm.$emit("onOk");
              } else {
                this.$message({
                  message: res.data.Message,
                  type: "error",
                });
              }
            })
            .finally(() => {
              vm.isLoading = false;
            });
        }
      });
    },
    handleChange(value) {
      const vm = this;
      let current = {};
      let typeName = "";
      value.forEach((x, i) => {
        if (i === 0) {
          current = vm.options.find((y) => y.id === x);
        } else {
          current = current.children.find((y) => y.id === x);
        }
        typeName = current.text;
      });
      vm.form.ParentName = typeName;
    },
    create(options, typeId) {
      const vm = this;
      vm.options = JSON.parse(JSON.stringify(options));
      const param = {
        id: typeId,
      };
      vm.isLoading = true;
      api
        .SelectNewsTypeById(param)
        .then((res) => {
          if (res.data.Code === 0) {
            vm.form = res.data.Data;
          }
        })
        .finally(() => {
          vm.isLoading = false;
        });
      vm.visible = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.box-btn {
  margin: 20px 10px 10px 10px;
  text-align: right;
}
</style>